import { BLOG_BODIES_EN } from './blog-bodies-en.js';

/**
 * PDF 指定 12 篇博客：slug、各语言 TDK、正文（英文为主，可后续扩写）
 */
export const blogPosts = [
	{
		slug: 'gbwhatsapp-vs-official-whatsapp-full-comparison-guide-2026',
		meta: {
			en: {
				title: 'GBWhatsApp vs Official WhatsApp: Full Comparison Guide 2026',
				description:
					'Compare GBWhatsApp vs official WhatsApp: privacy, themes, file limits, and MOD risks. Make an informed choice before you download.',
				keywords: 'gbwhatsapp vs whatsapp, gb whatsapp features comparison',
			},
			in: {
				title: 'GBWhatsApp बनाम आधिकारिक WhatsApp: पूर्ण तुलना 2026',
				description: 'GBWhatsApp और आधिकारिक WhatsApp की तुलना: गोपनीयता, थीम और जोखिम।',
				keywords: 'gbwhatsapp vs whatsapp, gb whatsapp comparison',
			},
			es: {
				title: 'GBWhatsApp vs WhatsApp oficial: comparativa 2026',
				description: 'Comparativa completa entre GBWhatsApp y WhatsApp oficial.',
				keywords: 'gbwhatsapp vs whatsapp, comparación gb whatsapp',
			},
			pt: {
				title: 'GBWhatsApp vs WhatsApp oficial: guia comparativo 2026',
				description: 'Compare recursos, privacidade e riscos entre GBWhatsApp e WhatsApp oficial.',
				keywords: 'gbwhatsapp vs whatsapp, comparação gb whatsapp',
			},
			id: {
				title: 'GBWhatsApp vs WhatsApp resmi: panduan perbandingan 2026',
				description: 'Bandingkan fitur, privasi, dan risiko MOD sebelum mengunduh.',
				keywords: 'gbwhatsapp vs whatsapp, perbandingan gb whatsapp',
			},
		},
		body: {
			en: BLOG_BODIES_EN['gbwhatsapp-vs-official-whatsapp-full-comparison-guide-2026'],
		},
	},
	{
		slug: 'is-gbwhatsapp-safe-to-use-in-2026-security-anti-ban-explained',
		meta: {
			en: {
				title: 'Is GBWhatsApp Safe to Use in 2026? Security & Anti-Ban Explained',
				description: 'Understand GBWhatsApp safety: anti-ban claims, APK integrity, backups, and how to reduce risk in 2026.',
				keywords: 'is gb whatsapp safe, gbwhatsapp anti ban',
			},
			in: { title: 'क्या GBWhatsApp 2026 में सुरक्षित है?', description: 'सुरक्षा, एंटी-बैन दावे और जोखिम कम करने के तरीके।', keywords: 'is gb whatsapp safe, gbwhatsapp anti ban' },
			es: { title: '¿Es seguro GBWhatsApp en 2026?', description: 'Seguridad, anti-ban y buenas prácticas al usar MODs.', keywords: 'is gb whatsapp safe, gbwhatsapp anti ban' },
			pt: { title: 'GBWhatsApp é seguro em 2026?', description: 'Entenda riscos, anti-ban e integridade do APK.', keywords: 'is gb whatsapp safe, gbwhatsapp anti ban' },
			id: { title: 'Apakah GBWhatsApp aman di 2026?', description: 'Keamanan, klaim anti-ban, dan mitigasi risiko.', keywords: 'is gb whatsapp safe, gbwhatsapp anti ban' },
		},
		body: {
			en: BLOG_BODIES_EN['is-gbwhatsapp-safe-to-use-in-2026-security-anti-ban-explained'],
		},
	},
	{
		slug: 'how-to-backup-and-restore-gbwhatsapp-chats',
		meta: {
			en: { title: 'How to Backup and Restore GBWhatsApp Chats Without Losing Data', description: 'Step-by-step backup and restore for GBWhatsApp on Android before switching phones or reinstalling.', keywords: 'gbwhatsapp backup restore, restore gb whatsapp chats' },
			in: { title: 'GBWhatsApp चैट बैकअप और रिस्टोर', description: 'Android पर बैकअप और रिस्टोर चरण।', keywords: 'gbwhatsapp backup restore' },
			es: { title: 'Cómo respaldar y restaurar chats de GBWhatsApp', description: 'Pasos recomendados antes de cambiar de teléfono.', keywords: 'gbwhatsapp backup restore' },
			pt: { title: 'Como fazer backup e restaurar chats do GBWhatsApp', description: 'Boas práticas antes de reinstalar o app.', keywords: 'gbwhatsapp backup restore' },
			id: { title: 'Cara backup dan restore chat GBWhatsApp', description: 'Langkah aman sebelum ganti perangkat.', keywords: 'gbwhatsapp backup restore' },
		},
		body: {
			en: BLOG_BODIES_EN['how-to-backup-and-restore-gbwhatsapp-chats'],
		},
	},
	{
		slug: 'how-to-update-gbwhatsapp-to-latest-version-safely',
		meta: {
			en: { title: 'How to Update GBWhatsApp to the Latest Version Safely', description: 'Update GBWhatsApp without losing chats: verify builds, migrate settings, and use official download mirrors.', keywords: 'update gb whatsapp, gbwhatsapp latest version update' },
			in: { title: 'GBWhatsApp को सुरक्षित रूप से अपडेट कैसे करें', description: 'नवीनतम संस्करण पर अपडेट करने के चरण।', keywords: 'update gb whatsapp' },
			es: { title: 'Cómo actualizar GBWhatsApp de forma segura', description: 'Actualice sin perder chats verificando el APK.', keywords: 'update gb whatsapp' },
			pt: { title: 'Como atualizar o GBWhatsApp com segurança', description: 'Passos para atualizar sem perder dados.', keywords: 'update gb whatsapp' },
			id: { title: 'Cara memperbarui GBWhatsApp dengan aman', description: 'Langkah update tanpa kehilangan chat.', keywords: 'update gb whatsapp' },
		},
		body: {
			en: BLOG_BODIES_EN['how-to-update-gbwhatsapp-to-latest-version-safely'],
		},
	},
	{
		slug: 'gbwhatsapp-not-working-common-problems-and-fixes',
		meta: {
			en: { title: 'GBWhatsApp Not Working? Common Problems and Fixes', description: 'Fix crashes, OTP issues, and sync errors on GBWhatsApp with structured troubleshooting.', keywords: 'gb whatsapp not working, gbwhatsapp problems fix' },
			in: { title: 'GBWhatsApp troubleshooting (HI)', description: 'Common issues and fixes for Hindi readers.', keywords: 'gb whatsapp not working' },
			es: { title: 'GBWhatsApp no funciona: soluciones', description: 'Problemas frecuentes y arreglos rápidos.', keywords: 'gb whatsapp not working' },
			pt: { title: 'GBWhatsApp não abre: correções comuns', description: 'Soluções para falhas e OTP.', keywords: 'gb whatsapp not working' },
			id: { title: 'GBWhatsApp error umum dan perbaikan', description: 'Crash, OTP, dan sinkronisasi.', keywords: 'gb whatsapp not working' },
		},
		body: {
			en: BLOG_BODIES_EN['gbwhatsapp-not-working-common-problems-and-fixes'],
		},
	},
	{
		slug: 'how-to-fix-gbwhatsapp-ban-issue',
		meta: {
			en: { title: 'How to Fix GBWhatsApp Ban Issue (Temporary & Permanent Ban Guide)', description: 'Understand temporary vs permanent bans and recovery options for GBWhatsApp users.', keywords: 'gb whatsapp banned, fix gbwhatsapp ban' },
			in: { title: 'GBWhatsApp ban fix guide', description: 'Temporary vs permanent ban tips for Indian users.', keywords: 'gb whatsapp banned' },
			es: { title: 'Cómo recuperarse de un baneo en GBWhatsApp', description: 'Guía de baneos temporales y permanentes.', keywords: 'gb whatsapp banned' },
			pt: { title: 'Como lidar com banimento no GBWhatsApp', description: 'Ban temporário vs permanente.', keywords: 'gb whatsapp banned' },
			id: { title: 'Cara mengatasi banned GBWhatsApp', description: 'Panduan ban sementara dan permanen.', keywords: 'gb whatsapp banned' },
		},
		body: {
			en: BLOG_BODIES_EN['how-to-fix-gbwhatsapp-ban-issue'],
		},
	},
	{
		slug: 'gbwhatsapp-privacy-settings-guide',
		meta: {
			en: { title: 'GBWhatsApp Privacy Settings Guide: Hide Online, Blue Ticks & More', description: 'Configure freeze last seen, hide blue ticks, and status privacy on supported GBWhatsApp builds.', keywords: 'gbwhatsapp privacy settings, hide online gb whatsapp' },
			in: { title: 'GBWhatsApp गोपनीयता सेटिंग्स', description: 'लास्ट सीन और ब्लू टिक विकल्प।', keywords: 'gbwhatsapp privacy settings' },
			es: { title: 'Guía de privacidad en GBWhatsApp', description: 'Última hora de conexión y doble check.', keywords: 'gbwhatsapp privacy settings' },
			pt: { title: 'Privacidade no GBWhatsApp', description: 'Online, ticks azuis e status.', keywords: 'gbwhatsapp privacy settings' },
			id: { title: 'Panduan privasi GBWhatsApp', description: 'Sembunyikan online dan centang biru.', keywords: 'gbwhatsapp privacy settings' },
		},
		body: {
			en: BLOG_BODIES_EN['gbwhatsapp-privacy-settings-guide'],
		},
	},
	{
		slug: 'best-gbwhatsapp-themes-and-customization-tips',
		meta: {
			en: { title: 'Best GBWhatsApp Themes and Customization Tips', description: 'Theme packs, fonts, and UI tweaks for GBWhatsApp power users.', keywords: 'gbwhatsapp themes, customize gb whatsapp' },
			in: { title: 'GBWhatsApp थीम और कस्टमाइज़ेशन', description: 'थीम पैक और फॉन्ट युक्तियाँ।', keywords: 'gbwhatsapp themes' },
			es: { title: 'Mejores temas para GBWhatsApp', description: 'Personalización y fuentes.', keywords: 'gbwhatsapp themes' },
			pt: { title: 'Temas e personalização no GBWhatsApp', description: 'Dicas para usuários avançados.', keywords: 'gbwhatsapp themes' },
			id: { title: 'Tema dan kustomisasi GBWhatsApp', description: 'Tips tampilan untuk pengguna lanjutan.', keywords: 'gbwhatsapp themes' },
		},
		body: {
			en: BLOG_BODIES_EN['best-gbwhatsapp-themes-and-customization-tips'],
		},
	},
	{
		slug: 'gbwhatsapp-vs-fmwhatsapp-which-mod-is-better',
		meta: {
			en: { title: 'GBWhatsApp vs FMWhatsApp: Which MOD is Better?', description: 'Compare GBWhatsApp and FMWhatsApp feature sets, update cadence, and stability.', keywords: 'gbwhatsapp vs fmwhatsapp, best whatsapp mod' },
			in: { title: 'GBWhatsApp बनाम FMWhatsApp', description: 'कौन सा MOD आपके लिए बेहतर है।', keywords: 'gbwhatsapp vs fmwhatsapp' },
			es: { title: 'GBWhatsApp vs FMWhatsApp', description: 'Comparación práctica entre MODs.', keywords: 'gbwhatsapp vs fmwhatsapp' },
			pt: { title: 'GBWhatsApp vs FMWhatsApp', description: 'Qual MOD escolher em 2026.', keywords: 'gbwhatsapp vs fmwhatsapp' },
			id: { title: 'GBWhatsApp vs FMWhatsApp', description: 'Perbandingan fitur dan stabilitas.', keywords: 'gbwhatsapp vs fmwhatsapp' },
		},
		body: {
			en: BLOG_BODIES_EN['gbwhatsapp-vs-fmwhatsapp-which-mod-is-better'],
		},
	},
	{
		slug: 'gbwhatsapp-vs-yowhatsapp-key-differences-explained',
		meta: {
			en: { title: 'GBWhatsApp vs YoWhatsApp: Key Differences Explained', description: 'Side-by-side look at YoWhatsApp vs GBWhatsApp for privacy, UI, and updates.', keywords: 'gbwhatsapp vs yowhatsapp' },
			in: { title: 'GBWhatsApp बनाम YoWhatsApp', description: 'मुख्य अंतर स्पष्ट किए गए।', keywords: 'gbwhatsapp vs yowhatsapp' },
			es: { title: 'GBWhatsApp vs YoWhatsApp', description: 'Diferencias clave entre MODs.', keywords: 'gbwhatsapp vs yowhatsapp' },
			pt: { title: 'GBWhatsApp vs YoWhatsApp', description: 'Comparativo direto de recursos.', keywords: 'gbwhatsapp vs yowhatsapp' },
			id: { title: 'GBWhatsApp vs YoWhatsApp', description: 'Perbedaan utama yang perlu diketahui.', keywords: 'gbwhatsapp vs yowhatsapp' },
		},
		body: {
			en: BLOG_BODIES_EN['gbwhatsapp-vs-yowhatsapp-key-differences-explained'],
		},
	},
	{
		slug: 'how-to-use-gb-whatsapp-caller-id',
		meta: {
			en: { title: "How to Use GB WhatsApp Caller ID to See Who's Calling", description: 'Caller ID overlays and spam hints on supported GBWhatsApp builds.', keywords: 'GB WhatsApp Caller ID' },
			in: { title: 'GB WhatsApp Caller ID guide', description: 'Caller identification on supported builds.', keywords: 'GB WhatsApp Caller ID' },
			es: { title: 'Caller ID en GB WhatsApp', description: 'Identificación de llamadas en builds compatibles.', keywords: 'GB WhatsApp Caller ID' },
			pt: { title: 'Caller ID no GB WhatsApp', description: 'Como ativar overlays de chamadas.', keywords: 'GB WhatsApp Caller ID' },
			id: { title: 'Caller ID di GB WhatsApp', description: 'Fitur identifikasi panggilan.', keywords: 'GB WhatsApp Caller ID' },
		},
		body: {
			en: BLOG_BODIES_EN['how-to-use-gb-whatsapp-caller-id'],
		},
	},
	{
		slug: 'how-to-transfer-whatsapp-data-to-gbwhatsapp-step-by-step',
		meta: {
			en: { title: 'How to Transfer WhatsApp Data to GBWhatsApp Step by Step', description: 'Migrate chats from official WhatsApp to GBWhatsApp with backups and compatible signatures.', keywords: 'transfer whatsapp to gbwhatsapp' },
			in: { title: 'WhatsApp से GBWhatsApp में डेटा स्थानांतरण', description: 'चरण-दर-चरण माइग्रेशन।', keywords: 'transfer whatsapp to gbwhatsapp' },
			es: { title: 'Transferir datos de WhatsApp a GBWhatsApp', description: 'Migración segura paso a paso.', keywords: 'transfer whatsapp to gbwhatsapp' },
			pt: { title: 'Transferir dados do WhatsApp para GBWhatsApp', description: 'Passo a passo com backup.', keywords: 'transfer whatsapp to gbwhatsapp' },
			id: { title: 'Memindahkan data WhatsApp ke GBWhatsApp', description: 'Langkah migrasi dengan cadangan.', keywords: 'transfer whatsapp to gbwhatsapp' },
		},
		body: {
			en: BLOG_BODIES_EN['how-to-transfer-whatsapp-data-to-gbwhatsapp-step-by-step'],
		},
	},
];

export function blogBySlug(slug) {
	return blogPosts.find((p) => p.slug === slug);
}
